// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1_L4g","approved":"Status_approved__34ysN","rejected":"Status_rejected__2OtTB","expired":"Status_expired__3KnQN","label":"Status_label__ZtSj8"};